export default __webpack_public_path__ + "static/media/H_sound.f9048d4d.mp3";